<template>
  <div class="jdz">
    <div class="content">
      <div>
        <template v-for="item in list">
          <div class="content-div" :key="item.id" style="margin-top:0.2rem">
            <div class="content-img">
              <div class="cm" style="width:100%;height:100%;">
                <img
                  class="card__img"
                  style="object-fit:cover;"
                  data-src="/../../assets/shuzang.png"
                  :src="item.background"
                  lazy="loaded"
                />
              </div>
            </div>
            <div class="zang-card-content">
              <p class="card-title" v-bind:style="{ color: item.color }">
                {{ item.title }}
              </p>
              <p class="card-desc" v-bind:style="{ color: item.color }">
                {{ item.subtitle }}
              </p>
              <p
                class="card-line"
                v-bind:style="{ 'border-bottom': '2px dashed', 'border-bottom-color': item.color }"
              ></p>
              <div v-html="item.content"></div>
            </div>
          </div>
        </template>
        <!-- <a name="huazang">&nbsp;</a>
        <div id="huazang" class="content-div">
          <div class="content-img">
            <div class="cm" style="width:100%;height:100%;">
              <img
                class="card__img"
                style="object-fit:cover;"
                data-src="/../../assets/huazang.png"
                src="../../assets/huazang.png"
                lazy="loaded"
              />
            </div>
          </div>
          <div class="zang-card-content">
            <p class="card-title" style="color:#A71E52;">
              花坛葬
            </p>
            <p class="card-desc" style="color:#A71E52;">
              与鲜花合二为一·生命美丽再延续
            </p>
            <p class="card-line" style="border-bottom:2px dashed #A71E52;"></p>
            <p class="card-p">
              花坛葬是起源于西方的绿色葬式，将骨灰埋入花坛中。
            </p>
            <p class="card-p">
              对于墓园来说花坛葬已经成为了墓园的一景，不再是阴森森的墓地，成为了路边的小花，也许没有人提醒很多人不知道小花的下面有骨灰，所以接受的人本身就有一种现代不张扬的精神境界，成为一朵朵路边的小花，为路过的人带来的是一片片绿叶，一阵阵花香。
            </p>
          </div>
        </div>
        <a name="caopingzang">&nbsp;</a>
        <div id="caopingzang" class="content-div">
          <div class="content-img">
            <div class="cm" style="width:100%;height:100%;">
              <img
                class="card__img"
                style="object-fit:cover;"
                data-src="/../../assets/caopingzang.png"
                src="../../assets/caopingzang.png"
                lazy="loaded"
              />
            </div>
          </div>
          <div class="zang-card-content">
            <p class="card-title" style="color:#A71E52;">
              草坪葬
            </p>
            <p class="card-desc" style="color:#A71E52;">
              草坪葬·让生命回归自然
            </p>
            <p class="card-line" style="border-bottom:2px dashed #A71E52;"></p>
            <p class="card-p">
              草坪葬是指在精心打理的草坪园区内，灌木成行排列，中间设有卧地纪念碑且具有整洁统一外观的福位。
            </p>
            <p class="card-p">
              草坪葬是源于西方的葬式。与芳草为伴，让生命生于自然，归于自然，吸取大地甘露，与天地合二为一。西洋风格与中华传统文化的完美结合，流畅的线条，给人视觉的美感。
            </p>
          </div>
        </div>
        <a name="bizang">&nbsp;</a>
        <div id="bizang" class="content-div">
          <div class="content-img">
            <div class="cm" style="width:100%;height:100%;">
              <img
                class="card__img"
                style="object-fit:cover;"
                data-src="/../../assets/bizang.png"
                src="../../assets/bizang.png"
                lazy="loaded"
              />
            </div>
          </div>
          <div class="zang-card-content">
            <p class="card-title" style="color:#A71E52;">
              壁葬
            </p>
            <p class="card-desc" style="color:#A71E52;">
              生前即独特·逝后亦不同
            </p>
            <p class="card-line" style="border-bottom:2px dashed #A71E52;"></p>
            <p class="card-p">
              壁葬是将骨灰盒嵌在墙壁内的丧葬方式，在安葬死者的同时为后人留福，是一种先进的殡葬理念和行为。
            </p>
            <p class="card-p">
              壁葬墓碑更为重视碑文的镶刻和墓碑四角的线刻纹饰，除了镶刻逝者的姓名和生卒年等信息，也可以添上一两句纪念逝者的墓志铭，并且可以在墓碑的四周线刻一些装饰的纹样，让墓碑看上去更为美观具有艺术效果。
            </p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jiedizang',
  components: {},
  data() {
    return {
      list: [],
    }
  },
  methods: {
    queryNaturalAll() {
      var that = this
      this.$queryAll(
        'OweNatural',
        { sort: { orderNum: 1 } },
        ['id', 'title', 'subtitle', 'color', 'background', 'content'],
        function(res) {
          that.$fill(that.list, res['data'])
        }
      )
    },
  },
  created() {
    this.queryNaturalAll()
  },
}
</script>

<style>
.jdz .banner {
  height: 3.73rem;
}
.jdz .title {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;
  margin-left: 0.5rem;
  margin-bottom: 0.53rem;
}
.jdz .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.jdz .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.jdz .content-div {
  position: relative;
}
.jdz .content-div .content-img {
  height: 16rem;
}
.jdz .cm {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}

.jdz .card__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.jdz .zang-card-content {
  width: 7.46667rem;
  height: 8.8rem;
  background: hsla(0, 0%, 100%, 0.8);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.8rem 0.4rem;
}
.jdz .content-div:first-child:after {
  content: '';
  width: 0.45333rem;
  height: 0.42667rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAfCAYAAABplKSyAAAAAXNSR0IArs4c6QAAA51JREFUWEe1l23In2MYxn+HlyhSmMIHrymUT+ODfJiXT2jzzmbUypa3lqKexlp5LVrMlESkkXd5KUoU8mXhi5XZPlALRaSmaIgdOp6u/7qfy/X/3/f/sR319NT/vu7zPK7zOq/zOG4B2D4euBzYKun9/LYvYfsA4Dhgh6Tdsn0UsA04siR+BrhV0p/7gojts4AXgFNK3kUhsQR4u0r4OXCFpO/2JhHbtwCPAAd14s6ExLGF0WFVwp+ApZI++r9EbB8KPAUsa8RaqdITZwOvAyHUxd/AGkkPz5eI7dNL7NMaMV4GrpslUYgcA7wGnNNY/Apwg6TfpyFj+1rgSSCV6OIvYEbSxvy4h0QhciDwKJCzq/ElcJmkr/uI2M6Z5+xbcb4Hrpa0eRRnDolOVVYATwAHVwl3AtdLemccEdsnAK8CuQU1PgCWS/q5+6BJolRlIfBGuc/dd3YD9+ZPkrsPbF8MPAccUWXPOw8Ad2cu1MzGkihEFgDph/Mbu0o1UpWdtvcvxNYA+1Vrf5ltPum9cdWbSKIQSYKHgNvrHgLSHzcBa4HzGkk+A66S9O2kPuol0emTpcDTwCF9jVmePx7iknITJmIwiVKVM4A3gZMnRP0NuFHSi33JJ96OSS/bPrzM/gsb66JBV0r6aiiBrJuqEp2jSfPdU3phFCPTb5WkVGIqjMZ2dncBsF1ShtIg2D4XiABulpRpOxiRc0mRBSJgEa4tQIZM7vB92WU9AwZH71lYvMuzQDbwYXxMSFwCvFW9+26525mQew1jhtltIXESkEbqanwSZwZEKwYfzzi2PcNs9agncq7PA7WniGqulJSmmxdsHw28VMpfx/gYuKgr5aeWGZD/XUQfoojxFbONNBS2FxUCsQl1zHiUOxOzlvJUYhNwaSNRHNY1tQK2CNlO3BngfiCmtotfgRWS9vThf+ZECRAtyByoxSieM94zHrSJMsyykcWNBbmFGWZzPMkkKc9EjCvODOniD2C1pOjI3BrbZxYvcWKDQK5lXPyu+lmflEcjohXRjBoxriEzK1C2bwY2NG5ZkmZdPiWa6B3btqOa2XVUtManOV9gHRA/WeObUv4vxhHI770kRi/bvgN4sNFouT2tOGm8NGAacSIGkyglj8PKzMhX2zjkGt8laX1f8tHzqUgUIvmGjPeMB63xQ/lg+mQogamOoxvUdlx43Hj6YYRMv2WSfpyGwLxJdPpkORABzDfEY5L+mZZA1v8L/wQx+C46LXQAAAAASUVORK5CYII=)
    no-repeat 50%/100% 100%;
  position: absolute;
  bottom: 0.8rem;
  left: 50%;
  transform: translateX(-50%);
}

.jdz .zang-card-content .card-title {
  font-size: 0.90667rem;
  line-height: 1.01333rem;
  letter-spacing: 0.53rem;
  text-align: center;
  margin-bottom: 0.16rem;
  padding-left: 0.53rem;
  color: #42692a;
}

.jdz .zang-card-content .card-desc {
  font-size: 0.37333rem;
  line-height: 0.53rem;
  text-align: center;
  margin-bottom: 0.27rem;
  color: #42692a;
}
.jdz .zang-card-content .card-p {
  font-size: 0.32rem;
  color: #333;
  line-height: 0.53rem;
  margin-bottom: 0.13333rem;
}
</style>
